import { FABRIC_CUSTOM_OBJECT } from '../../../utils';
import { updateConnector } from '../../fabric_flowchart';
import { polylineModified, updatePoints } from '../../utils';

export function pathArrowModified(e) {
  const target = e;
  polylineModified(target);
  return true;
}
export function diagramObjectModified(e) {
  const target = e;
  if (!e.isDiagram) return true;
  window.canvas.getObjects().forEach((polyline) => {
    if (
      (polyline.type === FABRIC_CUSTOM_OBJECT.polyline || polyline.name === FABRIC_CUSTOM_OBJECT.modifiableArrowLine) &&
      (polyline.toId === target.id || polyline.fromId === target.id)
    ) {
      const newPolyline = updatePoints(polyline, polyline?.name);
      updateConnector(newPolyline);
    }
  });
  return true;
}
